fx.ns("shared.stage.components", class BaseCalendarGrid extends shared.stage.base.BaseComponent {
    constructor(component, model, parent, manual, commands) {
        super(component, model, parent, commands);

        this.selectable = false;
        this.movable = false;
        this.editable = false;
        this.clickable = false;

        if (component) {
            this._calendarContent = JSON.parse(component.content);
            this._date = new Date(this._calendarContent.year, this._calendarContent.month - 1);
        }

        //this._cellClass = shared.stage.CalendarCell;
        this._cellClass = shared.stage.BaseCalendarCell;

        // The date for which to display the month. Defaults to the current date.


        // Months and days names
        this._dayNames = [fx.text("Lundi"),
        fx.text("Mardi"),
        fx.text("Mercredi"),
        fx.text("Jeudi"),
        fx.text("Vendredi"),
        fx.text("Samedi"),
        fx.text("Dimanche")];

        this._monthNames = [
            fx.text("Janvier"),
            fx.text("Février"),
            fx.text("Mars"),
            fx.text("Avril"),
            fx.text("Mai"),
            fx.text("Juin"),
            fx.text("Juillet"),
            fx.text("Août"),
            fx.text("Septembre"),
            fx.text("Octobre"),
            fx.text("Novembre"),
            fx.text("Décembre")
        ];

        this._grid = []; // Stores the structure of the calendar grid
        //this._currentDayComponents = {}; // Keeps track of active day components


        this._cellMargin = this.model.creation.isSinglePage ? 1 * this.model.creation.extraScale : 2 * this.model.creation.extraScale; // Margin between calendar cells
        this._horizontalMargin = 10 * this.model.creation.extraScale;
        this._daysRowTopMaring = this.model.creation.isSinglePage ? 5 * this.model.creation.extraScale : 15 * this.model.creation.extraScale;
        this._bottomMargin = this.model.creation.hasWhole ? 25 * this.model.creation.extraScale : 15 * this.model.creation.extraScale;
        this._headerBottomMargin = this.model.creation.isSinglePage ? 2 * this.model.creation.extraScale : 5 * this.model.creation.extraScale;

        this._fontService = fx.service("FontLoader", model.fonts);
    }


    get cellClass() {
        return this._cellClass;
    }

    set cellClass(val) {
        this._cellClass = val;
    }

    get monthGrid() {
        return this._grid;
    }

    get cellMargin() {
        return this._cellMargin;
    }

    set cellMargin(val) {
        this._cellMargin = val;
    }

    // horizontal margin
    get horizontalMargin() {
        return this._horizontalMargin;
    }

    set horizontalMargin(val) {
        this._horizontalMargin = val;
    }

    get bottomMargin() {
        return this._bottomMargin;
    }

    set bottomMargin(val) {
        this._bottomMargin = val;
    }

    get headerBottomMargin() {
        return this._headerBottomMargin;
    }

    set headerBottomMargin(val) {
        this._headerBottomMargin = val;
    }

    get daysRowTopMaring() {
        return this._daysRowTopMaring;
    }

    set daysRowTopMaring(val) {
        this._daysRowTopMaring = val;
    }

    get dayNames() {
        return this._dayNames;
    }

    set dayNames(val) {
        this._dayNames = val;
    }

    get monthNames() {
        return this._monthNames;
    }

    set monthNames(val) {
        this._monthNames = val;
    }

    /**
     * Get the currently displayed date.
     * @returns {Date}
     */
    get date() {
        if (!this._date)
            this._date = new Date();
        return this._date;
    }

    /**
     * Set the date and re-render the calendar grid.
     * @param {Date} val - The new date to display.
     */
    set date(val) {
        // if (val instanceof Date && val.getTime() !== this._date.getTime()) {
        this._date = val;
        if (this.initialized)
            this._dateUpdated();

        //}
    }

    get normalizedMonth() {
        return Date.normalize(this.date.getMonth() + 1);

        //let num = this.date.getMonth() + 1;
        //return ((Number(num) > 9) ? num : "0" + num);
    }

    // override
    refresh() { }

    /**
     * Component initialization.
     */
    create() {
        super.create();

        this.attr("data-drop-allowed", true);

        this.addClass("calendar-grid");

        if (this.model.creation.isSinglePage)
            this.addClass("single");

        this.container = new fx.components.Box("container");

        this.addChild(this.container, { top: 0, left: 0, width: "100%", height: "100%" });

        this.titleContainer = new fx.components.Box("title-container");

        this.monthTitle = new fx.components.Text({ text: this.monthNames[this.date.getMonth()], className: "calendar-month" });
        this.monthTitle.css({ fontSize: 12 * this.model.creation.extraScale + "px" });
        this.titleContainer.addChild(this.monthTitle, { top: 0, right: 16 * this.model.creation.extraScale, height: 20 * this.model.creation.extraScale });

        this.yearTitle = new fx.components.Text({ text: this.date.getFullYear(), className: "calendar-year" });
        this.yearTitle.css({ fontSize: 4 * this.model.creation.extraScale + "px" });
        this.titleContainer.addChild(this.yearTitle, { top: 13 * this.model.creation.extraScale, right: 16 * this.model.creation.extraScale, height: 20 * this.model.creation.extraScale });

        this.monthNumberTitle = new fx.components.Text({ text: this.normalizedMonth, className: "calendar-month-number" });
        this.monthNumberTitle.css({ fontSize: 18 * this.model.creation.extraScale + "px" });
        this.titleContainer.addChild(this.monthNumberTitle, { top: 0, height: 20 * this.model.creation.extraScale, left: 20 * this.model.creation.extraScale });

        this.container.addChild(this.titleContainer, { top: this.model.creation.isSinglePage ? 5 * this.model.creation.extraScale : 25 * this.model.creation.extraScale, height: 20 * this.model.creation.extraScale, width: "100%" });

        this.headerRow = new fx.components.Box("calendar-days");
        this.container.addChild(this.headerRow);
    }

    onDataEvent(event) {
        if (event.type == "edit-event-calendar") {
            let childs = this.container.getChilds();
            for (let i = 0; i < childs.length; i++) {
                let child = childs[i];
                if (child instanceof this.cellClass && child.day == event.detail.day) {
                    this.model.event("edit-text-calendar", { data: child.data, day: child.day, cellWidth: this.cellWidth, cellHeight: this.rowHeight });
                    break;
                }
            }
        }
    }

    onReady() {
        super.onReady();

        this._loadFonts();
    }

    onDisplayUpdated() {
        this.positionGrid();
    }

    positionGrid() {
        if (this.model.creation.isSinglePage) {
            this.css({
                width: this.model.creation.pageWidth,
                height: this.model.creation.pageHeight / 2,
                transform: "translate(0px," + (this.model.creation.pageHeight / 2) + "px)"
            });

            this.container.bottom((this.container.realHeight) / 2);
        }
        else {
            this.css({
                width: this.model.creation.pageWidth,
                height: this.model.creation.pageHeight,
                transform: "translate(0px," + this.model.creation.pageHeight + "px)"
            });

            this.container.bottom((this.realHeight - this.container.realHeight) / 2);
        }
    }

    _dateUpdated() 
    {
        this.monthTitle.text = this.monthNames[this.date.getMonth()];
        this.yearTitle.text = this.date.getFullYear();
        this.monthNumberTitle = this.normalizedMonth;
        this._buildGrid();
    }

    /**
     * Clears existing day components and re-renders the calendar grid.
     */
    _buildGrid() {
        this.cellWidth = (this.realWidth - 2 * this.horizontalMargin - 6 * this.cellMargin) / 7;

        this._clearDayComponents();
        this._grid = Date.generateMonthGrid(this._date);

        // if grid already displayed, let's clean everything first 
        //for (const id in this._currentDayComponents) {
        //    this._currentDayComponents[id].destroy();
        //}
        //this._currentDayComponents = {};

        this._addDaysHeader();

        this.rowHeight = (this.realHeight - (this.headerRow.top() + this.headerRow.height() + this.headerBottomMargin) - ((this._grid.length - 1) * this.cellMargin) - this.bottomMargin) / (this._grid.length);

        this._renderGrid();
    }

    /**
     * To Override
     * Renders the header with day names (Sun, Mon, Tue, etc.).
     * This method is called once during creation.
     */
    _addDaysHeader() {

        this.headerRow.viewport({ height: 8 * this.model.creation.extraScale, width: "100%", top: this.titleContainer.top() + this.titleContainer.height() + this.daysRowTopMaring });

        this.dayNames.forEach((name, index) => {
            const dayNameComponent = new fx.components.Text({ text: name, className: "calendar-day-name" });
            dayNameComponent.css({ fontSize: 5 * this.model.creation.extraScale + "px" });
            this.headerRow.addChild(dayNameComponent, {
                width: this.cellWidth,
                left: this.horizontalMargin + index * (this.cellWidth + this.cellMargin),
                height: "100%"
            });
        });

    }

    /**
     * Clears all currently displayed day components from the DOM.
     */
    _clearDayComponents() {

    }


    /**
     * Renders the day components onto the grid.
     * It reuses or creates new day components as needed.
     */
    _renderGrid() {
        this._grid.forEach((week, rowIndex) => {
            week.forEach((dayDate, colIndex) => {
                //const dayId = `day-${dayDate.toDateString()}`; // Unique ID for each day

                //let dayComponent = this._currentDayComponents[dayId];

                //if (!dayComponent) {
                // Create a new day component if it doesn't exist
                const isCurrentMonth = dayDate.getMonth() === this.date.getMonth();
                //const isToday = dayDate.toDateString() === new Date().toDateString();
                const isWeekend = (dayDate.getDay() === 6) || (dayDate.getDay() === 0);

                let dayComponent = new this.cellClass(this.data, dayDate.getDate(), this.model);
                if (this.cellClass === shared.stage.CalendarCell) {
                    dayComponent.css({ border: "solid " + 0.5 * this.model.creation.extraScale + "px #C6DAE1" });
                    dayComponent.css({ borderRadius: 2 * this.model.creation.extraScale + "px" });
                }
                this.container.addChild(dayComponent, {
                    width: this.cellWidth,
                    height: this.rowHeight,
                    left: this.horizontalMargin + colIndex * (this.cellWidth + this.cellMargin),
                    top: (this.headerRow.top() + this.headerRow.height() + this.headerBottomMargin) + rowIndex * (this.rowHeight + this.cellMargin)
                });

                if (!isCurrentMonth)
                    dayComponent.addClass("otherMonth");

                if (isWeekend)
                    dayComponent.addClass("week-end");

                dayComponent.addClass("hoverable");

                //this._currentDayComponents[dayId] = dayComponent;

                if (this.clickable)
                    this.on("click", this.onDayClick, dayComponent);
                //}
                //else {
                // update component position
                //    dayComponent.viewport({
                //        width: this.cellWidth,
                //        height: this.rowHeight,
                //        left: colIndex * (this.cellWidth + this.cellMargin),
                //        top: (2 * this.rowHeight) /* title + header */ + rowIndex * (this.rowHeight + this.cellMargin)
                //    });
                //}
            });
        });
    }



    /**
     * Handles click events on individual day components.
     * Triggers a "daySelected" event with the clicked date.
     * @param {fx.Component} component - The component representing the clicked day.
     */
    onDayClick(event) {

        let ui = fx.dom.parent(event.target, "." + this.cellClass.name);

        if (!ui) return;

        let component = this.container.getChild(ui.id);

        // Remove 'selected' class from previously selected day
        //if (this._selectedDayComponent) {
        //    this._selectedDayComponent.removeClass("selected");
        //}

        // Add 'selected' class to the newly clicked day
        //component.addClass("selected");
        //this._selectedDayComponent = component;

        //this.trigger("daySelected", component);

        this.model.event("edit-text-calendar", { data: component.data, day: component.day, cellWidth: this.cellWidth, cellHeight: this.rowHeight });
    }


    // Fonts
    _loadFonts() {
        let font = this._fontService.getFont('RockSalt');

        this.on("loaded", this._onFontLoaded, font);
        this.on("error", this._onFontError, font);

        if (!font.loading)
            this._fontService.load(font);
    }

    _onFontLoaded(e) {
        let font = e.detail;

        this.off("loaded", this._onFontLoaded, font);
        this.off("error", this._onFontError, font);

        if (this.component)
        {
            this.component.event("fonts-loaded");
            this.delay(this._buildGrid, 100);
        }
    }

    _onFontError(e) {
        let font = e.detail;

        this.off("loaded", this._onFontLoaded, font);
        this.off("error", this._onFontError, font);

        if (this.component)
        {
            this.component.event("font-loaded-error", { error: "font-loaded-error", details: font.name });
            this.delay(this._buildGrid, 100);
        }
    }

});